import { render, staticRenderFns } from "./msgVideo.vue?vue&type=template&id=97f789f2&scoped=true&"
import script from "./msgVideo.vue?vue&type=script&lang=js&"
export * from "./msgVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f789f2",
  null
  
)

export default component.exports